// Add this code inside the <head> tag in your theme.liquid file or as a separate JS file

document.addEventListener("DOMContentLoaded", function() {
    // Array of fake sales data
    const fakeSales = [
        { name: 'Jessica', location: 'Texas', product: 'Blossom Maternity Bra', color: 'Beige' },
        { name: 'Emily', location: 'California', product: 'Blossom Maternity Bra', color: 'White' },
        { name: 'Sarah', location: 'Illinois', product: 'Blossom Maternity Bra', color: 'Black' },
        { name: 'Olivia', location: 'Colorado', product: 'Blossom Maternity Bra', color: 'Coffee' },
        { name: 'Beatrice', location: 'Quebec', product: 'Blossom Maternity Bra', color: 'Sage Green' },
        { name: 'Mia', location: 'United Kingdom', product: 'Blossom Maternity Bra', color: 'Sage Green' },
        { name: 'Sophia', location: 'Australia', product: 'Blossom Maternity Bra', color: 'Deep Mauve' },
        { name: 'Charlotte', location: 'New Zealand', product: 'Blossom Maternity Bra', color: 'Beige' },
        { name: 'Amelia', location: 'France', product: 'Blossom Maternity Bra', color: 'White' },
        { name: 'Adriana', location: 'Mexico', product: 'Blossom Maternity Bra', color: 'Beige' },
        { name: 'Gloria', location: 'Germany', product: 'Blossom Maternity Bra', color: 'Black' },
        { name: 'Lily', location: 'Spain', product: 'Blossom Maternity Bra', color: 'Coffee' },
        { name: 'Ava', location: 'Portugal', product: 'Blossom Maternity Bra', color: 'Sage Green' },
        { name: 'Chloe', location: 'Scotland', product: 'Blossom Maternity Bra', color: 'Deep Mauve' },
        { name: 'Kloe', location: 'Nova Scotia', product: 'Blossom Maternity Bra', color: 'Coffee' },
        { name: 'Brooke', location: 'Florida', product: 'Blossom Maternity Bra', color: 'White' },
        { name: 'Macy', location: 'Texas', product: 'Blossom Maternity Bra', color: 'Sage Green' },
        { name: 'Heather', location: 'Alaska', product: 'Blossom Maternity Bra', color: 'Black' },
        { name: 'Georgia', location: 'Florida', product: 'Blossom Maternity Bra', color: 'Deep Mauve' },
        { name: 'Grace', location: 'Denmark', product: 'Blossom Maternity Bra', color: 'Coffee' },
        { name: 'Veronica', location: 'Mexico', product: 'Blossom Maternity Bra', color: 'Black' },
        { name: 'Ruby', location: 'Panama', product: 'Blossom Maternity Bra', color: 'Coffee' },
        { name: 'Jin', location: 'South Korea', product: 'Blossom Maternity Bra', color: 'Sage Green' },
        { name: 'Li-Ann', location: 'Singapore', product: 'Blossom Maternity Bra', color: 'Deep Mauve' },
        { name: 'Annabelle', location: 'Florida', product: 'Blossom Maternity Bra', color: 'Beige' },
        { name: 'Shannon', location: 'North Carolina', product: 'Blossom Maternity Bra', color: 'Sage Green' },
        { name: 'Nina', location: 'Thailand', product: 'Blossom Maternity Bra', color: 'White' },
        { name: 'Miyu', location: 'Japan', product: 'Blossom Maternity Bra', color: 'Black' },
        { name: 'Ella', location: 'Michigan', product: 'Blossom Maternity Bra', color: 'Deep Mauve' },
        { name: 'Adrienne', location: 'Indiana', product: 'Blossom Maternity Bra', color: 'Black' },
        { name: 'Charvi', location: 'New Jersey', product: 'Blossom Maternity Bra', color: 'White' },
        { name: 'Vaishnavi', location: 'New York', product: 'Blossom Maternity Bra', color: 'Beige' },
        { name: 'Ananya', location: 'California', product: 'Blossom Maternity Bra', color: 'Coffee' },
        { name: 'Valentina', location: 'Maryland', product: 'Blossom Maternity Bra', color: 'Sage Green' },
        { name: 'Mia', location: 'British Columbia', product: 'Blossom Maternity Bra', color: 'Beige' },
        { name: 'Abigail', location: 'Alberta', product: 'Blossom Maternity Bra', color: 'White' },
        { name: 'Zola', location: 'South Africa', product: 'Blossom Maternity Bra', color: 'Coffee' },
        { name: 'Leila', location: 'Morocco', product: 'Blossom Maternity Bra', color: 'Sage Green' },
        { name: 'Simone', location: 'Jamaica', product: 'Blossom Maternity Bra', color: 'Deep Mauve' },
        { name: 'Sandra', location: 'Mexico', product: 'Blossom Maternity Bra', color: 'White' },
        { name: 'Lúcia', location: 'Brazil', product: 'Blossom Maternity Bra', color: 'Beige' },
        { name: 'Sofia', location: 'Costa Rica', product: 'Blossom Maternity Bra', color: 'White' }
    ];

    // Function to show the fake notification
    function showFakeNotification() {
        const sale = fakeSales[Math.floor(Math.random() * fakeSales.length)];
        const message = `${sale.name} from ${sale.location} just bought a ${sale.product} in ${sale.color}!`;

        const notification = document.createElement('div');
        notification.className = 'fake-sale-notification';
        notification.innerHTML = message;

        // Style for the notification
        notification.style.position = 'fixed';
        notification.style.bottom = '20px';
        notification.style.left = '50%';
        notification.style.transform = 'translateX(-50%)';
        notification.style.backgroundColor = 'rgba(0, 0, 0, 0.7)';
        notification.style.color = '#fff';
        notification.style.padding = '10px 20px';
        notification.style.borderRadius = '5px';
        notification.style.fontSize = '14px';
        notification.style.zIndex = '9999';
        notification.style.animation = 'slide-up 1s ease-in-out';

        // Append notification to the body
        document.body.appendChild(notification);

        // Remove notification after 10 seconds
        setTimeout(function() {
            notification.remove();
        }, 10000);
    }

    // Trigger the fake notifications every 10-15 seconds
    setInterval(showFakeNotification, Math.random() * (100000 - 10000) + 10000);  // Random interval between 10 to 15 seconds
});
